export const sampleAddresses = [
  {
    id: 1,
    flatNumber: '12A',
    address: '123 High Street, London, SW1A 1AA',
    fullAddress: 'Flat 12A, 123 High Street, London, SW1A 1AA',
  },
  {
    id: 2,
    flatNumber: '5B',
    address: '45 Park Road, London, NW1 7QP',
    fullAddress: 'Flat 5B, 45 Park Road, London, NW1 7QP',
  },
  {
    id: 3,
    address: '8 Garden Close, London, E1 6BT',
    fullAddress: '8 Garden Close, London, E1 6BT',
  },
];

export const propertyData = {
  priceHistory: {
    labels: ['2020', '2021', '2022', '2023', '2024', '2025'],
    prices: [320000, 335000, 360000, 375000, 390000, 405000],
  },
  address: '123 Sample Street, Wimbledon, London',
  overview: {
    wealthyArea: '9/10',
    crimeRates: '2/10',
    quietLocation: true,
    goodAirQuality: true,
  },
  myHome: {
    previousSales: [
      { date: '2020-01-15', price: '£750,000' },
      { date: '2015-03-20', price: '£550,000' },
    ],
    planningHistory: [
      { date: '2021-05-10', description: 'Extension application', status: 'Approved' },
    ],
    planningSuccessRate: '85%',
    planningApprovalRating: 'High',
    restrictions: 2,
    broadband: {
      provider: 'Virgin Media',
      downloadSpeed: '362 Mbps',
      uploadSpeed: '36 Mbps',
      rating: 'Excellent',
    },
    councilTax: { band: 'E', price: '£2,500' },
    energyDetails: {
      propertyDetails: {
        floorArea: '178 m²',
        habitableRooms: 8,
        mainFuel: 'mains gas (not community)',
        extensions: 2,
        inspectionDate: '9/4/2014',
      },
      efficiency: {
        hotWater: 'Good',
        heatingControls: 'Average',
      },
      annualCosts: {
        heating: 1155,
        hotWater: 109,
        lighting: 91,
      },
      features: {
        walls: 'Solid brick, as built, no insulation (assumed)',
        roof: 'Pitched, no insulation (assumed)',
        windows: 'Partial double glazing',
      },
    },
    energyEfficiency: { band: 'C', yearCost: '£1,200' },
    propertyDetails: {
      floorArea: '150 sq m',
      habitableRooms: 5,
      mainFuel: 'Gas',
      extensions: 1,
    },
  },
  myStreet: {
    crimeStats: {
      total: 25,
      categories: {
        burglary: 3,
        assault: 2,
        other: 20,
      },
    },
    openPlanning: [{ type: 'Extension', status: 'Pending' }],
    hmos: 2,
  },
  myArea: {
    schools: [
      { name: 'Wimbledon High School', distance: '0.3 miles', rating: 'Outstanding' },
      { name: 'Dundonald Primary', distance: '0.4 miles', rating: 'Good' },
    ],
    foodStores: [
      { name: 'Tesco', distance: '0.3 miles', type: 'Supermarket' },
      { name: "Sainsbury's", distance: '0.3 miles', type: 'Supermarket' },
      { name: 'Waitrose', distance: '0.4 miles', type: 'Supermarket' },
      { name: 'Tesco Express', distance: '0.5 miles', type: 'Supermarket' },
    ],
    transport: [
      { name: 'Dundonald Road', distance: '0.4 miles', type: 'Underground' },
      { name: 'Wimbledon', distance: '0.4 miles', type: 'Rail' },
      { name: 'Wimbledon Chase', distance: '0.7 miles', type: 'Rail' },
      { name: 'Merton Park', distance: '0.8 miles', type: 'Underground' },
    ],
    housePrices: {
      average: '£750,000',
      trend: '+5.2% (2 years)',
    },
    averageRents: {
      '2 bed': '£1,800 pcm',
      '3 bed': '£2,500 pcm',
    },
  },
};
